import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Box,
  Container,
  Divider,
  Grid,
  Paper,
  Typography,
} from "@material-ui/core";
import fontConfig from "../../constants/fonts";
import PortFolioItem from "./PortFolioItem";
import LayoutContainer from "../../components/LayoutsContainer";
import MobileHidden from "../../components/Common/Hidden/MobileHidden";
import DesktopHidden from "../../components/Common/Hidden/DesktopHidden";
import PortFolioCarousel from "../../Layouts/Portfolio/PortFolioCarousel";
const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "#f1f1f1",
    height: "65vh",
    margin: "5vh 0vw",
    // paddingBottom: "5vh",
  },

  titleContainer: {},
  title: {
    ...fontConfig.bold,
    fontSize: "3rem",
    color: theme.palette.primary.main,
    fontFamily: "Montserrat",
    textTransform: "uppercase",
    letterSpacing: "0.1rem",
    // backgroundColor: theme.palette.primary.main,
    borderRadius: 100,
    // boxShadow: "5px 5px 20px rgba(0,0,0,0.2)",
    // width: "20%",
    // width: "15%",
    textAlign: "center",
    padding: "20px 20px 5px 20px",
    // padding: "10 30px",
    // wordWrap: "no-wrap",
  },
  personalityContainer: {
    marginTop: theme.spacing(3),
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  Paper: {
    backgroundColor: "transparent",
  },
  Divider: {
    backgroundColor: theme.palette.secondary.main,
    width: "10vw",
    height: "4px",
    borderRadius: 100,
  },
}));

const PortFolio = ({ data }) => {
  const classes = useStyles();

  return (
    <>
      <div className={classes.root}>
        <Container maxWidth="lg">
          <Paper elevation={0} className={classes.Paper}>
            {/* <LayoutContainer> */}
            {/* <div className={classes.Divider}>
            <Divider />
          </div> */}

            {data?.title && (
              <Grid container justify="center">
                <Grid item className={classes.titleContainer}>
                  <Typography variant="h6" className={classes.title}>
                    {data.title}
                  </Typography>
                </Grid>
                <Grid
                  item
                  lg={12}
                  container
                  alignItems="center"
                  justify="center"
                >
                  <Divider className={classes.Divider} />
                </Grid>
              </Grid>
            )}
            <Grid
              container
              spacing={2}
              className={classes.personalityContainer}
            >
              <MobileHidden>
                {data.data.map((man, index) => {
                  return (
                    <Grid item key={index}>
                      <PortFolioItem data={man} />
                    </Grid>
                  );
                })}
              </MobileHidden>
              <DesktopHidden>
                <PortFolioCarousel data={data?.data} />
              </DesktopHidden>
            </Grid>
          </Paper>
        </Container>

        {/* </LayoutContainer> */}
      </div>
    </>
  );
};
export default PortFolio;

// import React from "react";
// import { makeStyles } from "@material-ui/core/styles";

// const useStyles = makeStyles((theme) => ({
//   root: {
//     [theme.breakpoints.down("md")]: {
//       backgroundColor: "white",
//     },
//   },
// }));

// const PortFolio = () => {
//   const classes = useStyles();

//   return (
//     <div className={classes.root}>
//       <section
//         id="portfolioCarousel"
//         class="portfolio-carousel portfolio-classic pt-90 pb-70"
//       >
//         <div class="container">
//           <div class="row mb-50">
//             <div class="col-sm-12 col-md-12 col-lg-7">
//               <div class="heading">
//                 <span class="heading__subtitle">
//                   We Work With Global Industries!
//                 </span>
//                 <h3 class="heading__title mb-0">Featured portfolio</h3>
//               </div>
//             </div>
//             {/* <div class="col-sm-12 col-md-12 col-lg-5">
//               <div class="cta__banner">
//                 <div class="bg-img">
//                   <img
//                     src="assets/images/backgrounds/pattern/1.jpg"
//                     alt="background"
//                   />
//                 </div>
//                 <h5 class="cta__title">
//                   Dedicated Customer <br /> Teams &amp; An Agile Services
//                 </h5>
//                 <p class="cta__desc">
//                   Building relationships and portfolio that last. Serving an
//                   impressive list of long-term clients with experience and
//                   expertise in industries.
//                 </p>
//                 <a class="btn btn__white btn__link" href="#">
//                   {" "}
//                   View Our Works{" "}
//                 </a>
//               </div>
//             </div> */}
//           </div>
//           <div class="row">
//             <div class="col-sm-12 col-md-12 col-lg-12">
//               <div
//                 class="carousel owl-carousel carousel-arrows"
//                 data-slide="3"
//                 data-slide-md="2"
//                 data-slide-sm="1"
//                 data-autoplay="true"
//                 data-nav="true"
//                 data-dots="false"
//                 data-space="30"
//                 data-loop="true"
//                 data-speed="800"
//               >
//                 <div class="portfolio-item">
//                   <div class="portfolio__img">
//                     <img
//                       src="http://jepurpanchayat.com/assets/images/products/p3.jpg"
//                       alt="portfolio img"
//                     />{" "}
//                     {/* <a class="view__icon" href="#">
//                       View
//                     </a> */}
//                   </div>
//                   <div class="portfolio__content">
//                     <h4 class="portfolio__title">
//                       <a href="#">શ્રી અમરેન્દ્ર કુમાર રાકેશ​ આઇ. એ. એસ.</a>
//                     </h4>
//                     <div class="portfolio__cat">
//                       <a href="#">
//                         અધિક મુખ્ય સચિવશ્રી (પંચાયત, ગ્રામ ગૃહનિર્માણ અને ગ્રામ
//                         વિકાસ વિભાગ)
//                       </a>
//                       {/* <a href="#">oil &amp; Gas</a> */}
//                     </div>
//                   </div>
//                 </div>
//                 <div class="portfolio-item">
//                   <div class="portfolio__img">
//                     <img
//                       src="http://jepurpanchayat.com/assets/images/products/p4.jpg"
//                       alt="portfolio img"
//                     />{" "}
//                     {/* <a class="view__icon" href="#">
//                       View
//                     </a> */}
//                   </div>
//                   <div class="portfolio__content">
//                     <h4 class="portfolio__title">
//                       <a href="#">પ્રહલાદભાઈ એચ. પટેલ</a>
//                     </h4>
//                     <div class="portfolio__cat">
//                       <a href="#">ઉપ સરપંચશ્રી </a>
//                       <a href="#">+૯૧-૯૦૯ ૯૪૨ ૨૮૬૦</a>
//                     </div>
//                   </div>
//                 </div>
//                 <div class="portfolio-item">
//                   <div class="portfolio__img">
//                     <img
//                       src="http://jepurpanchayat.com/assets/images/products/p1.jpg"
//                       alt="portfolio img"
//                     />{" "}
//                     {/* <a class="view__icon" href="#">
//                       View
//                     </a> */}
//                   </div>
//                   <div class="portfolio__content">
//                     <h4 class="portfolio__title">
//                       <a href="#">શ્રી રામાજી રાણાજી વણઝારા</a>
//                     </h4>
//                     <div class="portfolio__cat">
//                       <a href="#">ગ્રામસેવક</a>
//                       <a href="#">+૯૧-૭૮૭૪૨૪૪૯૩૫</a>
//                     </div>
//                   </div>
//                 </div>
//                 {/* <div class="portfolio-item">
//                   <div class="portfolio__img">
//                     <img
//                       src="http://jepurpanchayat.com/assets/images/products/p2.jpg"
//                       alt="portfolio img"
//                     />{" "}
//                     <a class="view__icon" href="#">
//                       View
//                     </a>
//                   </div>
//                   <div class="portfolio__content">
//                     <h4 class="portfolio__title">
//                       <a href="#">Regulatory Compliance Seminar</a>
//                     </h4>
//                     <div class="portfolio__cat">
//                       <a href="#">Construction</a>
//                       <a href="#">Engineering</a>
//                     </div>
//                   </div>
//                 </div>
//                 <div class="portfolio-item">
//                   <div class="portfolio__img">
//                     <img
//                       src="http://jepurpanchayat.com/assets/images/products/p3.jpg"
//                       alt="portfolio img"
//                     />{" "}
//                     <a class="view__icon" href="#">
//                       View
//                     </a>
//                   </div>
//                   <div class="portfolio__content">
//                     <h4 class="portfolio__title">
//                       <a href="#">Documents &amp; Electronic Data</a>
//                     </h4>
//                     <div class="portfolio__cat">
//                       <a href="#">Engineering</a>
//                       <a href="#">oil &amp; Gas</a>
//                     </div>
//                   </div>
//                 </div> */}
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// };
// export default PortFolio;
